<template>
  <div>
    <transition name="fade" mode="out-in">
      <div v-show="!loading">
        <div class="wallpaper">
          <div
            class="blob-container"
            :class="{ 'dark-blobs': $vuetify.theme.dark }"
          >
            <div class="blob b1"/><div class="blob b2"/><div class="blob b3"/>
            <div class="blob b4"/><div class="blob b5"/><div class="blob b6"/>
            <div class="blob b7"/><div class="blob b8"/><div class="blob b9"/>
            <div class="blob b10"/><div class="blob b11"/><div class="blob b12"/>
            <div class="blob b13"/><div class="blob b14"/><div class="blob b15"/>
          </div>
        </div>

        <div>
          <svg
            viewBox="0 0 1320 400"
            :class="{ 'dark-svg': $vuetify.theme.dark }"
          >
            <text x="45%" y="25%" dy=".35em" text-anchor="middle">RED</text>
            <text x="45%" y="75%" dy=".35em" text-anchor="middle">CENTER</text>
          </svg>
        </div>

        <div class="right-form" style="overflow-y: scroll !important;">
          <v-card id="mainForm" elevation="0">
            <v-card color="transparent" :width="showRecovery ? ($vuetify.breakpoint.mdAndUp ? '550' : '350') : ($vuetify.breakpoint.mdAndUp ? '400' : '350')">
              <v-card-title v-if="!showRecovery" class="d-flex justify-center pt-4">
                <img
                  src="login-card-header.png"
                  :width="$vuetify.breakpoint.mdAndUp ? '250' : '200'"
                />
              </v-card-title>

              <!-- ── STEP 1: credentials ── -->
              <v-expand-transition>

              <v-form v-if="!mfaRequired" @submit.prevent="login" class="pa-12">
                <v-text-field
                  v-model="form.username"
                  prepend-icon="mdi-shield-account-outline"
                  label="Email"
                  type="email"
                  required
                />
                <v-text-field
                  v-model="form.password"
                  prepend-icon="mdi-lock-outline"
                  label="Contraseña"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  @click:append="show1 = !show1"
                />
                <v-btn
                  type="submit"
                  depressed
                  color="primary"
                  block
                  :loading="isLoadingLogin"
                  @click="login"
                >
                  Login
                </v-btn>
                <DownloadAppBtn class="mt-4"/>
              </v-form>

              <!-- ── STEP 2: OTP ── -->
              <div v-else class="pa-12">
                <p class="text-center text-body-2 mb-1">
                  <v-icon small class="mr-1">mdi-shield-key-outline</v-icon>
                  Introduce el código de tu app de autenticación
                </p>
                <p class="text-center text-caption grey--text mb-6">
                  {{ form.username }}
                </p>

                <div v-if="!showRecovery">
                  <div class="d-flex justify-center mb-6">
                    <v-otp-input
                      v-model="otpCode"
                      length="6"
                      type="number"
                      :disabled="isVerifying"
                      @finish="verifyOTP"
                    />
                  </div>

                  <v-btn
                    depressed
                    color="primary"
                    block
                    :loading="isVerifying"
                    :disabled="otpCode.length < 6"
                    @click="verifyOTP"
                  >
                    Verificar
                  </v-btn>
                </div>

                <!-- Recovery code toggle -->
                <div v-if="!showRecovery">
                  <v-btn
                    text
                    x-small
                    color="grey"
                    @click="showRecovery = true"
                    block
                  >
                    Usar código de recuperación
                  </v-btn>
                </div>

                <v-scale-transition>
                  <div v-if="showRecovery">
                    <v-alert
                      outlined
                      text
                      prominent
                      border="left"
                      color="info"
                      class="text-justify pa-4"
                    >
                      Tu autenticación 2FA será restablecida. Se enviará un nuevo
                      enlace de configuración a tu correo para configurarla nuevamente.
                      El anterior código de recuperación ya no será válido y
                      tampoco podrás usar el anterior código OTP.
                    </v-alert>
                    <v-tooltip right max-width="470px" v-if="recoveryAlert" color="grey darken-4">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          :color="recoveryAlert.type === 'info' ? 'blue' : recoveryAlert.type === 'success' ? 'green' : 'orange'"
                          dark v-bind="attrs" v-on="on" size="50" class="mb-3 d-flex justify-center"
                        >
                          {{ recoveryAlert.type === 'info' ? 'mdi-information-outline' : recoveryAlert.type === 'success' ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline' }}
                        </v-icon>
                      </template>
                      <v-alert
                        outlined
                        prominent
                        text
                        border="left"
                        :color="recoveryAlert.type"
                        class="text-justify pa-4"
                      >
                        {{ recoveryAlert.message }}
                      </v-alert>
                    </v-tooltip>
                    <v-btn
                      text
                      block
                      x-small
                      color="red"
                      class="mb-4"
                      @click="recoveryFields = Array(recoveryFieldCount).fill('')"
                      v-if="recoveryFields.some(field => field !== '')"
                    >
                      Limpiar
                    </v-btn>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                        v-for="(_, i) in recoveryFields"
                        :key="i"
                        class="mb-2"
                      >
                        <v-text-field
                          class="mx-1"
                          v-model="recoveryFields[i]"
                          :label="`Segmento ${i + 1} de ${recoveryFields.length}`"
                          :disabled="isVerifying"
                          outlined
                          dense
                          @paste="i === 0 && onRecoveryPaste($event)"
                          :maxlength="hexSegmentCodeLength"
                        />
                      </v-col>
                    </v-row>
                    <v-btn
                      depressed
                      color="warning"
                      block
                      :loading="isVerifying"
                      :disabled="recoveryAlert.type !== 'success'"
                      @click="verifyRecovery"
                    >
                      Usar código
                    </v-btn>
                    <v-btn
                      text
                      block
                      x-small
                      color="grey"
                      @click="showRecovery = false"
                    >
                      Volver a autenticación OTP
                    </v-btn>
                  </div>
                </v-scale-transition>

                <v-btn
                  text
                  block
                  x-small
                  color="info"
                  @click="resetToLogin()"
                >
                  Iniciar sesión con otra cuenta
                </v-btn>
              </div>
              </v-expand-transition>
            </v-card>
          </v-card>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { usernameErrors, passwordErrors } from './errorHandlers.js';
import DownloadAppBtn from './DownloadAppBtn.vue';

export default {
  name: 'Login',
  components: {
    DownloadAppBtn,
  },
  data: () => ({
    loading: false,
    show1: false,
    form: {
      username: '',
      password: '',
    },
    mfaRequired: false,
    mfaToken: null,
    otpCode: '',
    isVerifying: false,
    showRecovery: false,
    recoveryFieldCount: 6,
    recoveryCodeFieldLength: 8,
    recoveryFields: [],
  }),

  validations: {
    form: {
      username: { required },
      password: { required },
    },
  },

  computed: {
    usernameErrors,
    passwordErrors,
    expectedRecoveryCodeLength() {
      return this.recoveryFields.length * this.hexSegmentCodeLength;
    },
    hexSegmentCodeLength() {
      return this.recoveryCodeFieldLength * 2;
    },
    recoveryAlert() {
      const length = this.recoveryCodeMerged.length;
      const expected = this.expectedRecoveryCodeLength;
      const cleanRegex = new RegExp(`^[a-fA-F0-9]{0,${expected}}$`);
      const isValid = cleanRegex.test(this.recoveryCodeMerged);

      if ((length > 0 && length !== expected) || !isValid) {
        return {
          type: 'warning',
          message: `La longitud del código de recuperación no es correcta. 
                    Asegúrate de introducirlo sin espacios ni guiones. Debes
                    introducir ${expected} caracteres, actualmente tienes 
                    ${length}. Recuerda que el código debe ser hexadecimal 
                    (solo números y letras de la A a la F).`,
        };
      }

      if (length < expected) {
        return {
          type: 'info',
          message: `La longitud de los códigos de recuperación debe ser de 
                    ${expected} caracteres (${this.recoveryFields.length} 
                    segmentos de ${this.hexSegmentCodeLength} dígitos).
                    Puedes pegar el código completo en el primer campo, se 
                    distribuirá automáticamente.`,
        };
      }

      return {
        type: 'success',
        message: 'Código de recuperación listo para verificar.',
      };
    },
    recoveryCodeMerged() {
      return this.recoveryFields.join('').replace(/\s+/g, '');
    },
    ...mapState('login', {
      isLoadingLogin: (state) => state.isLoadingLogin,
    }),
    ...mapGetters('login', {
      isDistributor: 'isDistributor',
    }),
  },

  created() {
    this.tenant = /:\/\/([^\/]+)/
      .exec(window.location.href)[1]
      .split('.')[0];
    this.recoveryFields = Array(this.recoveryFieldCount).fill('');
  },

  beforeMount() {
    try {
      this.$store.dispatch('util/getMaintenanceStatus');
    } catch {}
  },

  methods: {
    onRecoveryPaste(event) {
      const pasted = (event.clipboardData || window.clipboardData)
        .getData('text')
        .replace(/\s+/g, '');

      if (!pasted) return;

      const chunkSize = Math.ceil(pasted.length / this.recoveryFieldCount);
      this.recoveryFields = Array.from({ length: this.recoveryFieldCount }, (_, i) =>
        pasted.slice(i * chunkSize, (i + 1) * chunkSize)
      );

      event.preventDefault();
    },

    async login() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit('login/isLoadingLogin', true);
      try {
        const result = await this.$store.dispatch('login/userLogin', {
          username: this.form.username,
          password: this.form.password,
        });

        if (result?.mfa_required) {
          this.mfaToken = result.mfa_token;
          this.mfaRequired = true;
          return;
        }

        await this.$store.dispatch('teletrabajo/getAgendadosToday');
        this.$router.push({ path: '/teletrabajo' });
      } catch (err) {
        const status = err.response?.status;
        let msg = err.response?.data?.error || err.response?.data?.detail || 'Error desconocido durante el inicio de sesión. Por favor, inténtalo de nuevo más tarde.';

        if (status === 404) {
          msg = 'Usuario no encontrado. Por favor, verifica tus credenciales.';
        } else if (status === 429) {
          msg = 'Parece que estás haciendo demasiadas solicitudes. Por favor, espera un momento e inténtalo de nuevo.';
        }

        this.$store.dispatch('util/showStatusSnackBar', {
          statusType: 'error',
          message: msg,
          timeout: 5000,
        });
      } finally {
        this.$store.commit('login/isLoadingLogin', false);
      }
    },

    async verifyOTP() {
      if (this.otpCode.length < 6 || this.isVerifying) return;
      await this._completeMFA({ code: this.otpCode });
    },

    async verifyRecovery() {
      if (!this.recoveryCodeMerged || this.isVerifying) return;
      await this._completeMFA({ recovery_code: this.recoveryCodeMerged });
    },

    async _completeMFA(payload) {
      this.isVerifying = true;
      try {
        await this.$store.dispatch('otpauth/verifyMFA', {
          mfa_token: this.mfaToken,
          ...payload,
        });
        if (!payload.recovery_code) {
          await this.$store.dispatch('teletrabajo/getAgendadosToday');
          await this.$store.dispatch('login/initialise');
          this.$router.push({ path: this.isDistributor ? '/teletrabajo' : '/fichaje' });
        } else {
          this.$store.dispatch('util/showStatusSnackBar', {
            statusType: 'success',
            message: 'Código de recuperación aceptado. Se ha enviado un nuevo enlace de enrollment a tu correo.',
            timeout: 8000,
          });
          this.resetToLogin();
        }
      } catch {
        this.otpCode = '';
      } finally {
        this.isVerifying = false;
      }
    },

    resetToLogin() {
      this.mfaRequired = false;
      this.mfaToken = null;
      this.otpCode = '';
      this.recoveryFields = Array(this.recoveryFieldCount).fill('');
      this.showRecovery = false;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@300;400;500;600;700&family=Poppins:wght@100;200;300;400;500;600;700;800&display=swap');

/* ── TRANSITIONS ── */
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease, transform 0.3s ease; }
.fade-enter, .fade-leave-to { opacity: 0; transform: translateY(10px); }

/* ── BLOBS BASE ── */
.blob-container {
  position: fixed;
  inset: 0;
  filter: blur(10px);
  pointer-events: none;
  z-index: 0;
}
.blob {
  border-radius: 50%;
  position: absolute;
  opacity: 0.60;
}

/* ── LIGHT MODE BLOBS — soft warm reds & rose tones ── */
.b1 { background: #ffc8c8; width: 340px; height: 340px; top: -60px;  left: -80px;  animation: bm1 18s ease-in-out infinite; }
.b2 { background: #ffd4b8; width: 260px; height: 260px; top: 50%;    right: -60px; animation: bm2 14s ease-in-out infinite; }
.b3 { background: #ffe4e4; width: 200px; height: 200px; top: 30%;    left: 10%;   animation: bm1 21s ease-in-out infinite; }
.b4 { background: #f4a0a0; width: 180px; height: 180px; bottom: 5%;  left: 5%;    animation: bm2 11s ease-in-out infinite; }
.b5 { background: #ffd4a8; width: 150px; height: 150px; bottom: 20%; right: 15%;  animation: bm1 16s ease-in-out infinite; }
.b6 { background: #e88080; width: 220px; height: 220px; top: 60%;    left: 40%;   animation: bm2 13s ease-in-out infinite; }
.b7 { background: #ffb3b3; width: 130px; height: 130px; top: 15%;    right: 30%;  animation: bm1 9s  ease-in-out infinite; }
.b8 { background: #f0c0c0; width: 180px; height: 180px; bottom: 0;   right: 5%;   animation: bm2 20s ease-in-out infinite; }
.b9 { background: #ff9999; width: 200px; height: 200px; top: 20%;    left: 50%;   animation: bm1 17s ease-in-out infinite; }
.b10 { background: #ff8080; width: 250px; height: 250px; top: 50%;    left: -100px; animation: bm2 12s ease-in-out infinite; }
.b11 { background: #f08080; width: 170px; height: 170px; top: 70%;    right: 20%;   animation: bm1 14s ease-in-out infinite; }
.b12 { background: #ffb3a8; width: 140px; height: 140px; bottom: 10%; right: 40%;   animation: bm2 18s ease-in-out infinite; }
.b13 { background: #ff9999; width: 190px; height: 190px; top: 40%;    left: 20%;   animation: bm1 10s ease-in-out infinite; }
.b14 { background: #f08080; width: 160px; height: 160px; top: 10%;   right: 10%;   animation: bm2 15s ease-in-out infinite; }
.b15 { background: #ffb3b3; width: 210px; height: 210px; bottom: 15%; left: 30%;   animation: bm1 13s ease-in-out infinite; }

/* ── DARK MODE BLOBS — deep atmospheric dark reds ── */
.dark-blobs { filter: blur(15px); }
.dark-blobs .b1 { background: #3d0000; opacity: 0.85; }
.dark-blobs .b2 { background: #5a0808; opacity: 0.85; }
.dark-blobs .b3 { background: #6b0000; opacity: 0.80; }
.dark-blobs .b4 { background: #420404; opacity: 0.85; }
.dark-blobs .b5 { background: #6a1500; opacity: 0.80; }
.dark-blobs .b6 { background: #4d0000; opacity: 0.85; }
.dark-blobs .b7 { background: #300000; opacity: 0.90; }
.dark-blobs .b8 { background: #551010; opacity: 0.80; }
.dark-blobs .b9 { background: #6b0000; opacity: 0.85; }
.dark-blobs .b10 { background: #4a0000; opacity: 0.85; }
.dark-blobs .b11 { background: #3d0000; opacity: 0.90; }
.dark-blobs .b12 { background: #5a0808; opacity: 0.80; }
.dark-blobs .b13 { background: #6b0000; opacity: 0.85; }
.dark-blobs .b14 { background: #420404; opacity: 0.85; }
.dark-blobs .b15 { background: #6a1500; opacity: 0.80; }

@keyframes bm1 { 0%,100% { transform: none } 50% { transform: translate(40px, 30px) scale(1.1) } }
@keyframes bm2 { 0%,100% { transform: none } 50% { transform: translate(-30px, 50px) scale(1.15) } }

/* ── RESET ── */
*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* ── WALLPAPER ── */
.wallpaper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

/* ── CARD ── */
#mainForm {
  opacity: 0.85;
}

/* ── FORM PANEL ── */
.right-form {
  display: flex;
  justify-content: right;
  margin-right: 200px;
  align-items: center;
  background-color: transparent;
  position: relative;
  z-index: 1;
  height: 90vh;
  overflow: hidden !important;
}

/* ── SVG — shared ── */
svg {
  font-family: Dosis !important;
  position: absolute;
  width: 100%;
  height: 100%;
  right: 15%;
  z-index: 1;
}

/* ── SVG TEXT — light mode ── */
svg text {
  text-transform: uppercase;
  animation: stroke-light 14s infinite alternate ease-out;
  stroke-width: 3;
  stroke: #6b0000;
  font-size: 150px;
}

/* ── SVG TEXT — dark mode ── */
svg.dark-svg text {
  animation: stroke-dark 14s infinite alternate ease-out;
  stroke: #ff8080;
}

/* ── LIGHT MODE STROKE ANIMATION ── */
@keyframes stroke-light {
  0% {
    fill: transparent;
    stroke: #6b0000;
    stroke-dashoffset: 25%;
    stroke-dasharray: 0 50%;
    stroke-width: 3;
  }
  25% {
    fill: transparent;
    stroke: #a00020;
    stroke-width: 3;
  }
  30% {
    fill: #1a0000;
    stroke: #1a0000;
    stroke-dashoffset: 0%;
    stroke-dasharray: 50% 0;
    stroke-width: 1;
  }
  80% {
    fill: #1a0000;
    stroke: #1a0000;
    stroke-dashoffset: 0%;
    stroke-dasharray: 50% 0;
    stroke-width: 1;
  }
  100% {
    fill: transparent;
    stroke: #6b0000;
    stroke-dashoffset: -25%;
    stroke-dasharray: 0 50%;
    stroke-width: 3;
  }
}

/* ── DARK MODE STROKE ANIMATION ── */
@keyframes stroke-dark {
  0% {
    fill: transparent;
    stroke: #ff8080;
    stroke-dashoffset: 25%;
    stroke-dasharray: 0 50%;
    stroke-width: 3;
  }
  25% {
    fill: transparent;
    stroke: #ffb3b3;
    stroke-width: 3;
  }
  30% {
    fill: #ffffff;
    stroke: #ffffff;
    stroke-dashoffset: 0%;
    stroke-dasharray: 50% 0;
    stroke-width: 1;
  }
  80% {
    fill: #ffffff;
    stroke: #ffffff;
    stroke-dashoffset: 0%;
    stroke-dasharray: 50% 0;
    stroke-width: 1;
  }
  100% {
    fill: transparent;
    stroke: #ff8080;
    stroke-dashoffset: -25%;
    stroke-dasharray: 0 50%;
    stroke-width: 3;
  }
}

/* ── MEDIA QUERIES ── */
@media (max-width: 1200px) {
  svg {
    position: relative;
    left: 5%;
    margin-bottom: -25%;
  }
}

@media (max-width: 670px) {
  svg { position: relative; margin-bottom: -25%; }
  svg text { font-size: 220px; }
  .right-form { justify-content: center; margin-left: 30px; margin-right: 30px; }
}

@media (max-width: 380px) {
  svg { position: relative; margin-bottom: -15%; }
  svg text { font-size: 220px; }
  .right-form { justify-content: center; margin-left: 30px; margin-right: 30px; }
}
</style>